interface BuildInfo {
  buildVersion: string;
  buildSha: string | null;
  buildLabel: string;
}

export const getAdminBuildInfo = (): BuildInfo => {
  // In Vitest (and any non-Vite runtime), Vite `define` globals may not be injected.
  // Access via `typeof` to avoid ReferenceError.
  const fallbackDefinedBuildVersion =
    typeof __HC_ADMIN_BUILD_VERSION__ === "string"
      ? __HC_ADMIN_BUILD_VERSION__
      : undefined;
  const fallbackDefinedBuildSha =
    typeof __HC_ADMIN_BUILD_SHA__ === "string"
      ? __HC_ADMIN_BUILD_SHA__
      : undefined;

  const buildVersion =
    import.meta.env.VITE_BUILD_VERSION ??
    fallbackDefinedBuildVersion ??
    "unknown";

  const buildShaRaw =
    import.meta.env.VITE_BUILD_SHA ?? fallbackDefinedBuildSha ?? "";
  const buildSha = buildShaRaw.trim().length > 0 ? buildShaRaw.trim() : null;

  const buildLabel = buildSha
    ? `${buildVersion} (${buildSha.slice(0, 8)})`
    : buildVersion;

  return { buildVersion, buildSha, buildLabel };
};
